var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Export',{attrs:{"workflow-key":_vm.workflowKey}})
}
var staticRenderFns = []

export { render, staticRenderFns }